const errorStore = {
    namespaced: true,
    state: {
        error: null
    },
    mutations: {
        set(state, text) {
            state.error = text;
        },
        reset(state) {
            state.error = null;
        }
    },
    getters: {
        error: state => state.error
    }
};

export default errorStore;